import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative flex flex-wrap lg:flex-nowrap bg-zinc-50" }
const _hoisted_2 = { class: "flex flex-col w-full lg:w-0 flex-1 max-h-[calc(100vh-95px)]" }
const _hoisted_3 = { class: "relative px-8 py-6 overflow-hidden bg-white" }
const _hoisted_4 = { class: "h-[30px] relative" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-white" }, "1", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-white" }, "2", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-[30px] h-[30px] rounded-full flex items-center justify-center bg-primary-500" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-white" }, "3")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "ml-3 text-sm font-bold whitespace-nowrap" }, "Select Date & Time", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "h-full p-5 overflow-auto lg:p-8" }
const _hoisted_14 = { class: "m-5 lg:m-0 w-full rounded-[10px] lg:rounded-none lg:w-[30%] lg:min-h-[calc(100vh-95px)] bg-white lg:border-l flex flex-col py-8 px-5 lg:px-7" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-700" }, "Booking Summary", -1)
const _hoisted_16 = { class: "block w-full pb-20 space-x-8 text-center mt-7 lg:hidden" }

import UserLayout from '@/layouts/UserLayout.vue';
import BookingSummary from '@/components/cards/BookingSummary.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';

import { ChevronRightIcon } from "@heroicons/vue/24/outline";

import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingLayout',
  props: {
    title: {
        type: String,
    },
    defaultTitle: {
        type: Boolean,
        default: true
    },
    hideNotification: {
        type: Boolean,
        default: false
    },
    step: {
        type: String,
    },
    previousStep: {
        type: String,
    },
    selected: {
        type: String
    },
    hideBackButton: {
        type: Boolean,
        default: false
    },
},
  setup(__props) {

const router = useRouter();




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, { showFooter: false }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["absolute flex items-center justify-between lg:w-full", __props.step == '1' ? 'left-0' : __props.step == '2' ? 'left-1/2 -translate-x-1/2' : __props.step == '3' ? 'right-0' : ''])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-[30px] h-[30px] rounded-full flex items-center justify-center", __props.previousStep == 1 || __props.previousStep == 2 ? 'bg-primary-200' : 'bg-primary-500'])
                  }, _hoisted_7, 2),
                  _createElementVNode("p", {
                    class: _normalizeClass(["ml-3 text-sm font-bold whitespace-nowrap", __props.previousStep == 1 || __props.previousStep == 2 ? 'text-primary-200' : ''])
                  }, "Choose Branch", 2)
                ]),
                _createVNode(_unref(ChevronRightIcon), {
                  class: _normalizeClass(["flex-shrink-0 w-4 h-4 mx-4", __props.previousStep == 1 || __props.previousStep == 2 ? 'text-primary-500' : 'text-primary-200'])
                }, null, 8, ["class"]),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center", [
                                __props.step == 2 || __props.previousStep == 2 ? '' : 'grayscale opacity-[0.25]',
                            ]])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-[30px] h-[30px] rounded-full flex items-center justify-center", __props.previousStep == 2 ? 'bg-primary-200' : 'bg-primary-500'])
                  }, _hoisted_9, 2),
                  _createElementVNode("p", {
                    class: _normalizeClass(["ml-3 text-sm font-bold whitespace-nowrap", __props.previousStep == 2 ? 'text-primary-200' : ''])
                  }, "Choose Package", 2)
                ], 2),
                _createVNode(_unref(ChevronRightIcon), {
                  class: _normalizeClass(["flex-shrink-0 w-4 h-4 mx-4", [__props.step == 2 ? 'text-primary-200' : 'text-darkgray-400', __props.previousStep == 2 ? 'text-primary-500' : '']])
                }, null, 8, ["class"]),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center", __props.step == 3 ? '' : 'grayscale opacity-[0.25]'])
                }, _hoisted_12, 2)
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(BookingSummary, {
            onBookNow: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/booking/confirmation')))
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(ButtonComponent, {
            secondary: "",
            "show-icon": false,
            text: "Go Back",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('back')), ["prevent"]))
          }),
          (!__props.hideBackButton)
            ? (_openBlock(), _createBlock(ButtonComponent, {
                key: 0,
                disabled: !__props.selected,
                text: "Continue",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('proceed')), ["prevent"]))
              }, null, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 3
  }))
}
}

})